import { Component, OnInit, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../../core/actions/invoice.actions';
import * as fromInvoice from '../../core/reducers/invoice.reducer';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { map, startWith, delay, filter } from 'rxjs/operators';
import { Invoice } from '../../shared/models/invoice';
import { InvoiceService } from '../../shared/services/invoice.service';
import { environment } from './../../../environments/environment';

import { saveAs } from 'file-saver';

@Component({
  selector: 'app-invoice-tab',
  templateUrl: './invoice-tab.component.html',
  styleUrls: ['./invoice-tab.component.scss']
})
export class InvoiceTabComponent implements OnInit, OnChanges {

	public invoice: Invoice = new Invoice;
	public edit: boolean = false;
	@Output() invoiceLoaded: EventEmitter<any> = new EventEmitter<any>();

	constructor(
		private store: Store<any>,
		private activatedRoute: ActivatedRoute,
		private invoiceService: InvoiceService,
		) { }

  	ngOnInit() {
	 	this.activatedRoute.params.subscribe(params => {
		  	if (params && params.id) {
		  		if (params.id > 0) {
		  			this.store.dispatch(new actions.OpenTabAction(params.id));
		  		}

		  		this.store.select(fromInvoice.selectOpenInvoices).pipe(
		  			map((invoices: any[]) => {
	          			return invoices.find(invoice => {
			 				if (invoice.oldId && invoice.oldId.toString() === params.id.toString()) {
	          					return true;
	          				}
		            		return invoice.id.toString() === params.id.toString();
	          			})
		  			}),
		  			filter(c => c && !c.loading )
		  		).subscribe(c => {
		  			this.invoice = c;
		  			if (this.invoice.saved) {
		  				this.edit = false;
		  			}
	  			    if (this.invoice && this.invoice.id < 0 ) {
					    this.edit = true;
    				}
		  		});
		    }
		});
	}

  	ngOnChanges(changes: SimpleChanges) {
  	}

	save(invoice: any) {
  		this.store.dispatch(new actions.SaveInvoiceAction(invoice));
	}
	cancel(event: any) {
  		this.edit = false;
	}
	editInvoice() {
		this.edit = true;
	}

	deleteInvoice() {
		this.store.dispatch(new actions.DeleteInvoiceAction(this.invoice.id));
	}

	doWorkflow(w: any) {
		console.log(w);
		this.store.dispatch(new actions.InvoiceWorkflowAction(this.invoice.id, w.action));
	}
	emailInvoice() {

		this.invoiceService.mailFile(this.invoice.id).subscribe(b => {});

        }

	sendPeppol() {
		this.doWorkflow({action: 'send-peppol', id: 'send-peppol'});
		//this.invoiceService.sendPeppol(this.invoice.id).subscribe(b => {});
	}

	printInvoice() {

		this.invoiceService.getFile(this.invoice.id).subscribe(b => {

        	const byteCharacters = atob(b.data);
        	const byteArrays = [];

        	for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            	const slice = byteCharacters.slice(offset, offset + 512);

            	const byteNumbers = new Array(slice.length);
            	for (let i = 0; i < slice.length; i++) {
	                byteNumbers[i] = slice.charCodeAt(i);
            	}

	            const byteArray = new Uint8Array(byteNumbers);
            	byteArrays.push(byteArray);
        	}

        	const newBlob = new Blob(byteArrays, { type:"application/pdf" });
        	saveAs(newBlob,"Facture " + this.invoice.number + ".pdf");
/*
            const data = window.URL.createObjectURL(newBlob);
				var link = document.createElement('a');
        	link.href = data;
        	link.download = "Facture " + this.invoice.number + ".pdf";
        	// this is necessary as link.click() does not work on the latest firefox
        	link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        	setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);	*/
		});
	}


	statusText(s: string): string {
		switch(s.toLowerCase()) {
			case 'sent':
				return 'Envoyé';
			case 'delivered':
				return 'Délivré';
			case 'created':
				return 'Créé';
			default:
				return s;
		}

	}
}
